// UI reducer types
export const SET_ERRORS = "SET_ERRORS";
export const LOADING_UI = "LOADING_UI";
export const CLEAR_ERRORS = "CLEAR_ERRORS";

// campaign-briefs reducer types
export const CAMPAIGN_BRIEF_PAGE_CHANGE = "CAMPAIGN_BRIEF_PAGE_CHANGE";
export const FETCH_BRIEF_FILTERS = "FETCH_BRIEF_FILTERS";
export const FETCH_BRIEF_FILTERS_SUCCESS = "FETCH_BRIEF_FILTERS_SUCCESS";
export const LOADING_BRIEFS = "LOADING_BRIEFS";
export const LIST_BRIEFS = "LIST_BRIEFS";

// new campaign reducer types
export const SHOW_NEW_CAMPAIGN_BRIEF_MODAL = "SHOW_NEW_CAMPAIGN_BRIEF_MODAL";
export const HIDE_NEW_CAMPAIGN_BRIEF_MODAL = "HIDE_NEW_CAMPAIGN_BRIEF_MODAL";

export const SHOW_ADD_PRODUCT_MODAL = "SHOW_ADD_PRODUCT_MODAL";
export const HIDE_ADD_PRODUCT_MODAL = "HIDE_ADD_PRODUCT_MODAL";

export const SHOW__WORK_ORDER_ADD_PRODUCT_MODAL = "SHOW__WORK_ORDER_ADD_PRODUCT_MODAL";
export const HIDE_WORK_ORDER_ADD_PRODUCT_MODAL = "HIDE_WORK_ORDER_ADD_PRODUCT_MODAL";

// review stages reducer types
export const LIST_STAGES = "LIST_STAGES";
export const LOADING_STAGES = "LOADING_STAGES";

// notifications reducer types
export const LIST_NOTIFICATIONS = "LIST_NOTIFICATIONS";
export const LOADING_NOTIFICATIONS = "LOADING_NOTIFICATIONS";
export const TOGGLE_NOTIFICATIONS_PANEL = "TOGGLE_NOTIFICATIONS_PANEL";

// permissions reducer types
export const LIST_PERMISSIONS = "LIST_PERMISSIONS";
export const LOADING_PERMISSIONS = "LOADING_PERMISSIONS";

// shared avatars types
export enum SharedAvatarsType {
  GRID_TYPE = "GRID_TYPE",
  LIST_TYPE = "LIST_TYPE",
}

// brief types
export enum BriefType {
  CAMPAIGN_BRIEF = "campaign-briefs",
  EXECUTION_BRIEF = "execution-briefs",
  WORK_ORDER = "work-orders",
}

export enum UserGroup {
  ADMIN = "ADMIN",
  CAMPAIGN_MANAGERS = "CAMPAIGN_MANAGERS",
  CHANNEL_PRIMES = "CHANNEL_PRIMES",
  CONTENT_CREATORS = "CONTENT_CREATORS",
  EXECUTIVE_MANAGERS = "EXECUTIVE_MANAGERS",
  GENERAL_USERS = "GENERAL_USERS",
  INVENTORY_REVIEWERS = "INVENTORY_REVIEWERS",
  MARKETING_DIRECTORS = "MARKETING_DIRECTORS",
  MERCH_OWNERS = "Merch Owners",
  PRODUCTION_COORDINATORS = "PRODUCTION_COORDINATORS",
  PRODUCTION_DIRECTORS = "PRODUCTION_DIRECTORS",
  WORK_ORDER_MANAGERS = "WORK_ORDER_MANAGERS",
}
